import makeStyles from "@material-ui/core/styles/makeStyles";
import React, {useEffect, useState} from "react";
import Typography from "@material-ui/core/Typography";
import {Checkbox, Divider, List, ListItem, ListItemIcon, ListItemText, Slider, TextField} from "@material-ui/core";
import Grid from "@material-ui/core/Grid";
import SearchIcon from "@material-ui/icons/Search";
import clsx from "clsx";
import Button from "@material-ui/core/Button";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import {useDispatch, useSelector} from "react-redux";
import {
    clearCheckboxTires, removeCheckboxTire,
    setBrandsList,
    setClassificationList,
    setFilteredResult,
    setLoadsList,
    setOriginalEquipment,
    setSearchTerm,
    setSearchSort,
    setSpeedRatingList,
    setTireTypesList,
    updateFilters,
    setFilterDialogFlag,
    setTireSizeDialogFlag,
} from "../../core/redux/ActionCreator";
import Dialog from "@material-ui/core/Dialog";
import Slide from "@material-ui/core/Slide";
import Drawer from "@material-ui/core/Drawer";


const transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="right" ref={ref} {...props} />;
});

function FilterMenu() {
    const dispatch = useDispatch();
    const spinner = useSelector(state => state.searchResultReducer.spinner);
    const results = useSelector(state => state.searchResultReducer.results);
    const selected = useSelector(state => state.searchResultReducer.checkboxes);
    const filteredResults = useSelector(state => state.searchResultReducer.filteredResults);
    const filterDialogOpen = useSelector(state => state.searchResultReducer.filterDialogFlag);
    const [open, setOpen] = useState(false);
    const [openDrawer, setOpenDrawer] = useState(false);
    const [expandedOpen, setExpandedOpen] = useState(false);
    const [tireBrands, setTireBrands] = useState([...new Set(results.map(value => value.brand).sort(function (a, b) {
        return a > b ? 1 : -1
    }))]);
    const brandsList = useSelector(state => state.searchResultReducer.brandsList);
    const [speedRating, setSpeedRating] = useState([...new Set(results.map(value => value.speedRating).sort(function (a, b) {
        return a > b ? 1 : -1
    }))]);
    const speedRatingList = useSelector(state => state.searchResultReducer.speedRatingList);
    const [loads, setLoads] = useState([...new Set(results.map(value => value.load).sort(function (a, b) {
        return a > b ? 1 : -1
    }))]);
    const loadsList = useSelector(state => state.searchResultReducer.loadsList);
    const [tireTypes, setTireTypes] = useState([...new Set(results.map(value => value.tireType).sort(function (a, b) {
        return a > b ? 1 : -1
    }))]);
    const tireTypesList = useSelector(state => state.searchResultReducer.tireTypesList);
    const [classification, setClassification] = useState([]);
    const classificationList = useSelector(state => state.searchResultReducer.classificationList);
    const sortValue = useSelector(state => state.searchResultReducer.sortValue);
    const searchTerm = useSelector(state => state.searchResultReducer.searchTerm);


    const useStyles = makeStyles((theme) => ({
        root: {
            display: 'flex',
        },
        hide: {
            display: 'none',
        },
        dialog: {
            flexShrink: 0,
            padding: theme.spacing(0, 1),
        },
        drawer: {
            width: '30%',
            flexShrink: 0,
        },
        mobileDrawerPaper: {
            width: '100%',
            padding: '1rem',
        },
        desktopDrawerPaper: {
            padding: '1rem',
        },
        dialogHeader: {
            display: 'flex',
            alignItems: 'center',
            padding: theme.spacing(0, 1),
            ...theme.mixins.toolbar,
            justifyContent: 'flex-end',
        },
        drawerHeader: {
            display: 'flex',
            padding: '10px 20px',
            flexDirection: 'column',
            alignItems: 'baseline',
        },
        content: {
            flexGrow: 1,
            padding: theme.spacing(3),
            transition: theme.transitions.create('margin', {
                easing: theme.transitions.easing.sharp,
                duration: theme.transitions.duration.leavingScreen,
            }),
            marginLeft: 0,
        },
        contentShift: {
            transition: theme.transitions.create('margin', {
                easing: theme.transitions.easing.easeOut,
                duration: theme.transitions.duration.enteringScreen,
            }),
            marginLeft: 0,
        },
    }));
    const classes = useStyles();

    useEffect(() => {
        if (!spinner && results.length !== 0) {
            if (tireBrands.length === 0) {
                setTireBrands([...new Set(results.map(value => value.brand).sort(function (a, b) {
                    return a > b ? 1 : -1
                }))]);
            }
            if (speedRating.length === 0) {
                setSpeedRating([...new Set(results.map(value => value.speedRating).sort(function (a, b) {
                    return a > b ? 1 : -1
                }))]);
            }
            if (loads.length === 0) {
                setLoads([...new Set(results.map(value => value.load).sort(function (a, b) {
                    return a > b ? 1 : -1
                }))]);
            }
            if (tireTypes.length === 0) {
                setTireTypes([...new Set(results.map(value => value.tireType).sort(function (a, b) {
                    return a > b ? 1 : -1
                }))]);
            }
        }
    }, [loads, tireTypes, results, tireBrands, speedRating, spinner, dispatch]);

    useEffect(() => {
        if (spinner) {
            setTireBrands([]);
            setSpeedRating([]);
            setClassification([]);
            setTireTypes([]);
            setLoads([]);
            dispatch(setSearchTerm(''));
            setTireTypes([]);
            setClassification([]);
        }
    }, [spinner, dispatch]);

    useEffect(() => {
        if (brandsList.length === 0 && tireBrands.length !== 0) {
            let brandArr = [];
            tireBrands.forEach((brand) => brandArr.push({'name': brand, 'selected': false}));
            dispatch(setBrandsList([...brandArr]));
        }
    }, [brandsList, tireBrands, dispatch]);

    useEffect(() => {
        if (classification.length === 0) {
            setClassification([{'name': 'Original Equipment', 'selected': false}, {
                'name': 'Replacement',
                'selected': false
            }]);
        }
        if (classificationList.length === 0 && classification.length !== 0) {
            dispatch(setClassificationList([...classification]));
        }
    }, [classification, classificationList, dispatch]);

    useEffect(() => {
        if (speedRatingList.length === 0 && speedRating.length !== 0) {
            let speedRatingArr = [];
            speedRating.forEach((rating) => speedRatingArr.push({'name': rating, 'selected': false}));
            dispatch(setSpeedRatingList([...speedRatingArr]));
        }
    }, [speedRatingList, speedRating, dispatch]);

    useEffect(() => {
        if (loadsList.length === 0 && loads.length !== 0) {
            let loadsArr = [];
            loads.forEach((rating) => loadsArr.push({'name': rating, 'selected': false}));
            dispatch(setLoadsList([...loadsArr]));
        }
    }, [loadsList, loads, dispatch]);

    useEffect(() => {
        if (tireTypesList.length === 0 && tireTypes.length !== 0) {
            let typesArr = [];
            tireTypes.forEach((rating) => typesArr.push({'name': rating, 'selected': false}));
            dispatch(setTireTypesList([...typesArr]));
        }
    }, [tireTypesList, tireTypes, dispatch]);

    const handleDialogOpen = () => {
        setOpen(true);
        dispatch(setFilterDialogFlag({filterDialogFlag: true}));
        dispatch(setTireSizeDialogFlag({tireSizeDialogFlag: false}));
    };

    const handleDrawerOpen = () => {
        setOpenDrawer(true);
        dispatch(setFilterDialogFlag({filterDialogFlag: true}));
        dispatch(setTireSizeDialogFlag({tireSizeDialogFlag: false}));
    };

    const handleDrawerClose = () => {
        setOpen(false);
        setOpenDrawer(false);
        dispatch(setFilterDialogFlag({filterDialogFlag: false}));
        setExpandedOpen(false);
    };

    const handleExpandOpen = () => {
        setExpandedOpen(true);
    };

    function PriceSlider() {
        const minPrice = Math.floor(Math.min(...filteredResults.map(value => value.price)));
        const maxPrice = Math.ceil(Math.max(...filteredResults.map(value => value.price)));
        const minSliderPrice = Math.floor(Math.min(...results.map(value => value.price)));
        const maxSliderPrice = Math.ceil(Math.max(...results.map(value => value.price)));
        const [value, setValue] = useState([minPrice, maxPrice]);
        const useStyles = makeStyles({
            root: {
                maxWidth: 255,
            },
        });

        function valuetext(value) {
            return `$${Math.floor(value)}`;
        }

        const classes = useStyles();

        const handleChange = (event, newValue) => {
            setValue(newValue);
        };

        function handleResultsChange() {
            let filteredTires= results.filter(result => ((result.price <= value[1]) && (result.price >= value[0])));
            let applyUserFilter = [];
            brandsList.forEach(brand =>{if(brand.selected) applyUserFilter.push(brand.name)});
            speedRatingList.forEach(speed=>{if(speed.selected) applyUserFilter.push(speed.name)});
            loadsList.forEach(loads=>{if(loads.selected) applyUserFilter.push(loads.name)});
            tireTypesList.forEach(tireTypes=>{if(tireTypes.selected) applyUserFilter.push(tireTypes.name)});
            classificationList.forEach(OEMType=>{if(OEMType.selected) applyUserFilter.push(OEMType.name)});

            if(applyUserFilter.length >0){
                let updatedResults = filteredTires.filter(items =>{
                    return applyUserFilter.includes(items.brand || items.speedRating || items.load || items.tireTypes ||
                        ('Original Equipment' && items.originalEquipment) ||( 'Replacement' && !items.originalEquipment))});

                updatedResults.sort(function (a, b) {
                    return a['price'] - b['price']
                });
                setOEMTires(updatedResults);
            }else{
                filteredTires.sort(function (a, b) {
                    return a['price'] - b['price']
                });
                setOEMTires(filteredTires);
            }
        }

        function setOEMTires(tireList){
            let tempOE = [];
            let i;
            tireList.forEach(result => {
                if (result.originalEquipment === true) {
                    tempOE.push(result);
                }
            });
            tempOE.sort(function (a, b) {
                return b['price'] - a['price']
            });
            for (i = 0; i < tireList.length; i++) {
                if (tireList[i].originalEquipment === true) {
                    tireList.splice(i, 1);
                    i--;
                }
            }
            tempOE.forEach(result => {
                tireList.unshift(result);
            });

            dispatch(setOriginalEquipment(tempOE));
            if(selected){
                let removeCompare = [];
                tireList.forEach(item =>{ if(selected.includes(item.gmPartNum)){
                    item.selected = true;
                    removeCompare.push(item.gmPartNum);
                }});

                //removed checkedTires not in result list
                if(removeCompare.length ===0){
                    dispatch(clearCheckboxTires(true));
                }else{
                    selected.forEach(parts => {if(!removeCompare.includes(parts))
                        dispatch(removeCheckboxTire(parts)); })
                }
            }
            dispatch(setFilteredResult([...tireList]));
        }

        return (
            <div className={classes.root}>
                <Typography id="range-slider" gutterBottom>
                    <b>Price</b>
                </Typography>
                <Slider
                    value={value}
                    min={minSliderPrice}
                    max={maxSliderPrice}
                    onChange={handleChange}
                    onChangeCommitted={handleResultsChange}
                    valueLabelDisplay="auto"
                    aria-labelledby="range-slider"
                    getAriaValueText={valuetext}
                    className={'stat-slider'}
                    data-dtm={'filter:price'}
                />
                <div id='priceFields' className={'priceFields'}>
                    <TextField
                        label="$ Min"
                        variant="filled"
                        value={value[0]}
                        className={'priceField stat-input-field'}
                        data-dtm={'filter:price'}
                        InputProps={{
                            readOnly: true,
                        }}
                    />
                    <TextField
                        label="$ Max"
                        variant="filled"
                        value={value[1]}
                        className={'priceField stat-input-field'}
                        data-dtm={'filter:price'}
                        InputProps={{
                            readOnly: true,
                        }}
                    />
                </div>
            </div>
        );
    }

    const handleClearFilters = () => {
        let tempOE = [];
        let i;
        results.sort(function (a, b) {
            return a['price'] - b['price']
        });
        results.forEach(result => {
            if (result.originalEquipment === true) {
                tempOE.push(result);
            }
        });
        tempOE.sort(function (a, b) {
            return b['price'] - a['price']
        });
        for (i = 0; i < results.length; i++) {
            if (results[i].originalEquipment === true) {
                results.splice(i, 1);
                i--;
            }
        }
        tempOE.forEach(result => {
            results.unshift(result);
        })

        dispatch(setSearchSort('Sort By'));
        dispatch(setSearchTerm(''));
        dispatch(setOriginalEquipment(tempOE));
        dispatch(setFilteredResult([...results]));
        dispatch(setBrandsList([]));
        dispatch(setSpeedRatingList([]));
        dispatch(setLoadsList([]));
        dispatch(setTireTypesList([]));
        dispatch(setClassificationList([{'name': 'Original Equipment', 'selected': false}, {
            'name': 'Replacement',
            'selected': false
        }]));
        if(selected){
            results.forEach(item =>{if(selected.includes(item.gmPartNum)) item.selected= true})
        }else{
            //removed compared tires when result updates
            dispatch(clearCheckboxTires(true));
        }
    };

    const FilterBody = () => {
        const useStyles = makeStyles((theme) => ({
            margin: {
                margin: theme.spacing(1),
            },
        }));
        const classes = useStyles();

        const handleChange = (value, props) => {
            let rest = [...results];
            let tempOE = [];
            let i;
            let index = props.findIndex(item => item.name === value.name);
            props[index].selected = !value.selected;
            let checked = [];
            let x;
            brandsList.forEach((item) => {
                if (item.selected) {
                    checked.push(item.name);
                }
            });
            speedRatingList.forEach((item) => {
                if (item.selected) {
                    checked.push(item.name);
                }
            });
            loadsList.forEach((item) => {
                if (item.selected) {
                    checked.push(item.name);
                }
            });
            tireTypesList.forEach((item) => {
                if (item.selected) {
                    checked.push(item.name);
                }
            });
            classificationList.forEach((item) => {
                if (item.selected) {
                    checked.push(item.name);
                }
            });

            for (x = 0; x < checked.length; x++) {
                if (tireBrands.includes(checked[x])) {
                    rest = rest.filter((result) => {
                        return checked.find(element => {
                            return element === result.brand;
                        });
                    });
                }
                if (speedRating.includes(checked[x])) {
                    rest = rest.filter((result) => {
                        return checked.find(element => {
                            return element === result.speedRating;
                        });
                    });
                }
                if (loads.includes(checked[x])) {
                    rest = rest.filter((result) => {
                        return checked.find(element => {
                            return element === result.load;
                        });
                    });
                }
                if (tireTypes.includes(checked[x])) {
                    rest = rest.filter((result) => {
                        return checked.find(element => {
                            return element === result.tireType;
                        });
                    });
                }
                if (checked[x] === 'Original Equipment') {
                    rest = rest.filter((result) => {
                        return result.originalEquipment === true;
                    });
                }
                if (checked[x] === 'Replacement') {
                    rest = rest.filter((result) => {
                        return result.originalEquipment === false;
                    });
                }
            }
            if (rest.length === 0) {
                console.log('rest empty');
                dispatch(setFilteredResult([]));
                dispatch(updateFilters({updateFilter: true}));
                //removed compared tires when result updates
                dispatch(clearCheckboxTires(true));
            } else {
                dispatch(updateFilters({updateFilter: false}));
                if (checked.length === 0) {
                    if (sortValue === 'priceLH') {
                        results.sort(function (a, b) {
                            return a['price'] - b['price']
                        });
                        results.forEach(result => {
                            if (result.originalEquipment === true) {
                                tempOE.push(result);
                            }
                        });
                        tempOE.sort(function (a, b) {
                            return b['price'] - a['price']
                        });
                        for (i = 0; i < results.length; i++) {
                            if (results[i].originalEquipment === true) {
                                results.splice(i, 1);
                                i--;
                            }
                        }
                        tempOE.forEach(result => {
                            results.unshift(result);
                        })
                    } else if (sortValue === 'priceHL') {
                        results.sort(function (a, b) {
                            return b['price'] - a['price']
                        });
                        results.forEach(result => {
                            if (result.originalEquipment === true) {
                                tempOE.push(result);
                            }
                        });
                        tempOE.sort(function (a, b) {
                            return b['price'] - a['price']
                        });
                        for (i = 0; i < results.length; i++) {
                            if (results[i].originalEquipment === true) {
                                results.splice(i, 1);
                                i--;
                            }
                        }
                        tempOE.forEach(result => {
                            results.unshift(result);
                        })
                    } else if (sortValue === 'brandAZ') {
                        results.sort(function (a, b) {
                            return a.brand === b.brand ?
                                a.name === b.name ? 0 : a.name > b.name ? 1 : -1 :
                                a.brand > b.brand ? 1 : -1
                        });
                        results.forEach(result => {
                            if (result.originalEquipment === true) {
                                tempOE.push(result);
                            }
                        });
                        tempOE.sort(function (a, b) {
                            return a.brand === b.brand ?
                                a.name === b.name ? 0 : a.name > b.name ? 1 : -1 :
                                a.brand > b.brand ? 1 : -1
                        });
                        for (i = 0; i < results.length; i++) {
                            if (results[i].originalEquipment === true) {
                                results.splice(i, 1);
                                i--;
                            }
                        }
                        tempOE.forEach(result => {
                            results.unshift(result);
                        })
                    } else if (sortValue === 'brandZA') {
                        results.sort(function (a, b) {
                            return a.brand === b.brand ?
                                a.name === b.name ? 0 : a.name > b.name ? -1 : 1 :
                                a.brand > b.brand ? -1 : 1
                        });
                        results.forEach(result => {
                            if (result.originalEquipment === true) {
                                tempOE.push(result);
                            }
                        });
                        tempOE.sort(function (a, b) {
                            return a.brand === b.brand ?
                                a.name === b.name ? 0 : a.name > b.name ? -1 : 1 :
                                a.brand > b.brand ? -1 : 1
                        });
                        for (i = 0; i < results.length; i++) {
                            if (results[i].originalEquipment === true) {
                                results.splice(i, 1);
                                i--;
                            }
                        }
                        tempOE.forEach(result => {
                            results.unshift(result);
                        })
                    }
                    dispatch(setOriginalEquipment(tempOE));
                    resetCompareTire([...results]);
                } else {
                    if (sortValue === 'priceLH') {
                        rest.sort(function (a, b) {
                            return a['price'] - b['price']
                        });
                    } else if (sortValue === 'priceHL') {
                        rest.sort(function (a, b) {
                            return b['price'] - a['price']
                        });
                    } else if (sortValue === 'brandAZ') {
                        rest.sort(function (a, b) {
                            return a.brand === b.brand ?
                                a.name === b.name ? 0 : a.name > b.name ? 1 : -1 :
                                a.brand > b.brand ? 1 : -1
                        });
                    } else if (sortValue === 'brandZA') {
                        rest.sort(function (a, b) {
                            return a.brand === b.brand ?
                                a.name === b.name ? 0 : a.name > b.name ? -1 : 1 :
                                a.brand > b.brand ? -1 : 1
                        });
                    }
                    resetCompareTire(rest);
                }
            }
        };

        const resetCompareTire= (results)=>{
            if(selected){
                let removeCompare = [];
                results.forEach(item =>{ if(selected.includes(item.gmPartNum)){
                    item.selected = true;
                    removeCompare.push(item.gmPartNum);
                }});

                //removed checkedTires not in result list
                if(removeCompare.length ===0){
                    dispatch(clearCheckboxTires(true));
                }else{
                    selected.forEach(parts => {if(!removeCompare.includes(parts))
                        dispatch(removeCheckboxTire(parts)); })
                }
            }
            dispatch(setFilteredResult(results));
        }

        const handleSearchBrandTextField = (e) => {
            e.preventDefault();
            if (e.target.value) {
                dispatch(setSearchTerm(e.target.value));
                dispatch(setBrandsList([]));
            } else {
                dispatch(setSearchTerm(''));
            }

        };


        return (
            <>
                <List>
                    <div className={'brandHeader'}><b>Brands</b></div>
                    <div className={classes.margin}>
                        <div className={classes.margin}>
                            <Grid container space={1} alignItems='flex-end'>
                                <Grid item>
                                    <SearchIcon/>
                                </Grid>
                                <Grid>
                                    <TextField
                                        onBlur={handleSearchBrandTextField}
                                        placeholder='Search Brands'
                                        className={'stat-search-input'}
                                        data-dtm={'filter:brands'}
                                        defaultValue={searchTerm}
                                        onKeyPress={(ev) => {
                                            console.log(`Pressed keyCode ${ev.key}`);
                                            if (ev.key === 'Enter') {
                                                ev.preventDefault();
                                                handleSearchBrandTextField(ev);
                                            }
                                        }}
                                    />
                                </Grid>
                            </Grid>
                        </div>
                        <br/>
                        <List>
                            <List>
                                {brandsList.filter((term) => {
                                    return term.name.toUpperCase().includes(searchTerm.toUpperCase())
                                }).map(function (value) {
                                    const labelId = `checkbox-list-label-${value}`;
                                    return (
                                        <ListItem key={value.name} onClick={() => handleChange(value, brandsList)}
                                                  aria-label={value.name} className={'stat-checkbox'}
                                                  data-dtm={'filter:brands'}>
                                            <ListItemIcon>
                                                <Checkbox
                                                    value={value}
                                                    checked={value.selected}
                                                    edge="start"
                                                    inputProps={{'aria-labelledby': labelId}}
                                                />
                                            </ListItemIcon>
                                            <ListItemText id={labelId} primary={`${value.name}`}
                                                          style={{cursor: 'pointer'}}/>
                                        </ListItem>
                                    );
                                })}
                            </List>
                        </List>
                    </div>
                </List>
                <Divider/>
                <List>
                    <PriceSlider/>
                    <div>
                        <Button
                            data-dtm={'search results'}
                            className={clsx(expandedOpen && classes.hide, 'stat-text-link')}
                            onClick={handleExpandOpen}
                        >More Filters</Button>
                        {expandedOpen && <div>
                            <Divider/>
                            <List>
                                <br/>
                                <div className={'brandHeader'}><b>Speed Rating</b></div>
                                <List>
                                    {speedRatingList.map(function (value) {
                                        const labelId = `checkbox-list-label-${value}`;
                                        return (
                                            <ListItem key={value.name} aria-label={value.name}
                                                      onClick={() => handleChange(value, speedRatingList)}
                                                      className={'stat-checkbox'}
                                                      data-dtm={'filter:speed rating'}>
                                                <ListItemIcon>
                                                    <Checkbox
                                                        value={value}
                                                        checked={value.selected}
                                                        edge="start"
                                                        inputProps={{'aria-labelledby': labelId}}
                                                    />
                                                </ListItemIcon>
                                                <ListItemText id={labelId} primary={`${value.name}`}
                                                              style={{cursor: 'pointer'}}/>
                                            </ListItem>
                                        );
                                    })}
                                </List>
                            </List>
                            <Divider/>
                            <List>
                                <br/>
                                <div className={'brandHeader'}><b>Classification</b></div>
                                <List>
                                    {classificationList.map(function (value) {
                                        const labelId = `checkbox-list-label-${value}`;
                                        return (
                                            <ListItem key={value.name}
                                                      onClick={() => handleChange(value, classificationList)}
                                                      className={'stat-checkbox'}
                                                      data-dtm={'filter:classification'}>
                                                <ListItemIcon>
                                                    <Checkbox
                                                        value={value}
                                                        checked={value.selected}
                                                        edge="start"
                                                        inputProps={{'aria-labelledby': labelId}}
                                                    />
                                                </ListItemIcon>
                                                <ListItemText id={labelId} primary={`${value.name}`}
                                                              style={{cursor: 'pointer'}}/>
                                            </ListItem>
                                        );
                                    })}
                                </List>
                            </List>
                            <br/>
                            <Divider/>
                            <List>
                                <div className={'brandHeader'}><b>Loads</b></div>
                                <List>
                                    {loadsList.map(function (value) {
                                        const labelId = `checkbox-list-label-${value}`;
                                        return (
                                            <ListItem key={value.name} onClick={() => handleChange(value, loadsList)}
                                                      className={'stat-checkbox'}
                                                      data-dtm={'filter:loads'}>
                                                <ListItemIcon>
                                                    <Checkbox
                                                        value={value}
                                                        checked={value.selected}
                                                        edge="start"
                                                        inputProps={{'aria-labelledby': labelId}}
                                                    />
                                                </ListItemIcon>
                                                <ListItemText id={labelId} primary={`${value.name}`}
                                                              style={{cursor: 'pointer'}}/>
                                            </ListItem>
                                        );
                                    })}
                                </List>
                            </List>
                            <br/>
                            <Divider/>
                            <List>
                                <div className={'brandHeader'}><b>Tire Types</b></div>
                                <List>
                                    {tireTypesList.map(function (value) {
                                        const labelId = `checkbox-list-label-${value}`;
                                        return (
                                            <ListItem key={value.name}
                                                      onClick={() => handleChange(value, tireTypesList)}
                                                      className={'stat-checkbox'}
                                                      data-dtm={'filter:tire types'}>
                                                <ListItemIcon>
                                                    <Checkbox
                                                        value={value}
                                                        checked={value.selected}
                                                        edge="start"
                                                        inputProps={{'aria-labelledby': labelId}}
                                                    />
                                                </ListItemIcon>
                                                <ListItemText id={labelId} primary={`${value.name}`}
                                                              style={{cursor: 'pointer'}}/>
                                            </ListItem>
                                        );
                                    })}
                                </List>
                            </List>
                        </div>}
                    </div>
                    <div>
                        <Button
                            aira-label="open drawer"
                            onClick={handleDrawerClose}
                            data-dtm={'filters'}
                            className='button primary-button stat-button-link'
                            fullWidth={true}
                        >Apply Filters</Button>
                        <br/>
                    </div>
                    <div
                        onClick={handleClearFilters}
                        color="primary"
                        className={'clearFilters stat-button-link'}
                        data-dtm={'filters'}
                        style={{cursor: 'pointer',marginTop: '15px', marginBottom: '15px'}}
                    >Clear Filters
                    </div>
                </List>
            </>
        )
    };

    return (
        <>
            <div className={'hide-on-desktop'}>
                <div className={'filterMenuButton'}>
                    <Button
                        data-dtm={'search results'}
                        aira-label="open drawer"
                        onClick={handleDialogOpen}
                        color="primary"
                        className={clsx(open && filterDialogOpen && classes.hide, 'button primary-button stat-button-link')}
                    >Filters</Button>
                </div>
                <Dialog
                    fullScreen
                    TransitionComponent={transition}
                    open={open && filterDialogOpen}
                    onClose={handleDrawerClose}
                    classes={{
                        paper: classes.mobileDrawerPaper,
                    }}
                >
                    <div className={classes.dialogHeader}>
                        <IconButton onClick={handleDrawerClose}>
                            <CloseIcon/>
                        </IconButton>
                    </div>
                    <FilterBody/>
                </Dialog>
            </div>
            <div className={'hide-on-mobile'}>
                <div className={'filterMenuButton'}>
                    <Button
                        data-dtm={'search results'}
                        aira-label="open drawer"
                        onClick={handleDrawerOpen}
                        color="primary"
                        className={clsx(openDrawer && filterDialogOpen && classes.hide, 'button primary-button stat-button-link')}
                    >Filters</Button>
                </div>
                <Drawer variant='persistent' anchor='left' open={openDrawer && filterDialogOpen} className={classes.drawer}
                        classes={{paper: classes.desktopDrawerPaper}}>
                    <div className={classes.drawerHeader}>
                        <IconButton onClick={handleDrawerClose}>
                            <CloseIcon/>
                        </IconButton>
                    </div>
                    <FilterBody/>
                </Drawer>
            </div>
        </>
    );
}

export default FilterMenu






